import React, { Component } from 'react';
import classNames from 'classnames/bind';

import { DataBlocks, Link, Button, Picture } from 'components';

import detectMobileOs from 'utils/detectMobileOS';

import PropTypes from 'prop-types';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

class MPBanner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deepLink: null,
      downloadApp: null,
    };
  }

  componentDidMount() {
    const {
      mobileLink,
      desktopLink,
      googlePlay,
      appStore,
    } = this.props.bannerData;
    const android = (detectMobileOs() === 'Android') && googlePlay;
    const ios = (detectMobileOs() === 'iOS') && appStore;

    this.setState({
      deepLink: detectMobileOs() ? mobileLink : desktopLink,
      downloadApp: android || ios,
    });
  }

  render() {
    const {
      imageDesktop,
      imageMobile,
      title,
      description,
      buttonText,
    } = this.props.bannerData;

    const { deepLink, downloadApp } = this.state;

    const pictureContentProps = [
      {
        image: imageDesktop,
        media: '(min-width: 700px)',
      }, {
        image: imageMobile,
        media: '(max-width: 699px)',
      },
    ];

    return (
      <DataBlocks.AnimationWrapper>
        <section className={cx('component')}>
          <Picture
            defaultImage={imageDesktop}
            className={cx('bannerImage')}
            content={pictureContentProps}
          />

          <div className={cx('content')}>
            {buttonText ? (
              <span dangerouslySetInnerHTML={{ __html: title }} className={cx('title')} />
            ) : (
              <Link href={deepLink} className={['hideVisitedColor', cx('deepLink')]}>
                <span dangerouslySetInnerHTML={{ __html: title }} />
              </Link>
            )}
            <div className={cx('description')} dangerouslySetInnerHTML={{ __html: description }} />

            {downloadApp ? (
              <a href={downloadApp.link} target="_blank" rel="noopener noreferrer">
                <img src={downloadApp.image} alt="" className={cx('downloadImage')} />
              </a>
            ) : (
              buttonText && deepLink && (
                <Button className={cx('button')} href={deepLink}>
                  {buttonText}
                </Button>
              ))}
          </div>
        </section>
      </DataBlocks.AnimationWrapper>
    );
  }
}

MPBanner.propTypes = {
  bannerData: PropTypes.shape({
    imageDesktop: PropTypes.string,
    imageMobile: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    buttonText: PropTypes.string,
    mobileLink: PropTypes.string,
    desktopLink: PropTypes.string,
    googlePlay: PropTypes.shape({
      image: PropTypes.string,
      link: PropTypes.string,
    }),
    appStore: PropTypes.shape({
      image: PropTypes.string,
      link: PropTypes.string,
    }),
  }),
};

export default MPBanner;
